import { DiscountFunnel } from 'app/src/features/Shopping/Discount/components/DiscountFunnel'
import { shoppingApi } from 'app/src/services/welfareportal'
import { ErrorPage, PageWidget } from 'app/src/shared/components'
import { ProgressSpinner } from 'primereact/progressspinner'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export function Discount(): ReactElement {
  const params = useParams()
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.Discount' })

  const discountDetailsResponse = shoppingApi.useOrderGet({
    pathParams: { orderId: params['id']! },
  })

  return (
    <PageWidget>
      <>
        {discountDetailsResponse.isLoading || discountDetailsResponse.isFetching ? (
          <>
            <h1 className='welfareportal-titlecenter'>{t('loadingInProgressTitle')}</h1>
            <div className='mt-20 flex'>
              <div className='mx-auto'>
                <ProgressSpinner data-testid='loading-element' className='flex' />
              </div>
            </div>
          </>
        ) : discountDetailsResponse.isError ? (
          <ErrorPage
            errorMessage={
              discountDetailsResponse.error.status == 404 ? t('discountNotFoundMessage') : t('loadingInProgressErrorMessage')
            }
          />
        ) : (
          discountDetailsResponse.data && <DiscountFunnel order={discountDetailsResponse.data} />
        )}
      </>
    </PageWidget>
  )
}
